/**
 * Registrazione Service Worker — TAS Command
 *
 * Usa workbox-window per gestire il ciclo di vita del SW
 * e notificare l'utente quando è disponibile un aggiornamento.
 */
import { Workbox } from 'workbox-window';

let wb = null;

/**
 * Registra il service worker.
 * @param {Object} callbacks
 * @param {Function} [callbacks.onSuccess]  - SW installato per la prima volta
 * @param {Function} [callbacks.onUpdate]   - Nuova versione SW in attesa
 */
export function registerSW(callbacks = {}) {
  if (!('serviceWorker' in navigator)) {
    console.info('[SW] Service Worker non supportato da questo browser.');
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.info('[SW] Registrazione saltata in modalità sviluppo.');
    return;
  }

  wb = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`);

  // Nuovo SW disponibile ma in attesa (c'è già un SW attivo)
  wb.addEventListener('waiting', () => {
    console.info('[SW] Nuova versione disponibile.');
    callbacks.onUpdate?.();
  });

  // SW attivato: distingue prima installazione da aggiornamento
  let swIsUpdate = false;
  wb.addEventListener('activated', (event) => {
    if (!event.isUpdate) {
      console.info('[SW] Installazione completata — app disponibile offline.');
      callbacks.onSuccess?.();
    } else {
      swIsUpdate = true;
    }
  });

  wb.addEventListener('controlling', () => {
    // Ricarica solo in caso di aggiornamento SW, non alla prima installazione
    if (swIsUpdate) {
      console.info('[SW] Nuovo SW attivo — ricarico la pagina.');
      window.location.reload();
    }
  });

  wb.register()
    .then(() => console.info('[SW] Registrato correttamente.'))
    .catch((err) => console.error('[SW] Registrazione fallita:', err));
}

/**
 * Dice al SW in attesa di saltare la fase di waiting e attivarsi subito.
 * Da chiamare dopo conferma utente ("Aggiorna ora").
 */
export function aggiornaSW() {
  if (wb) {
    wb.messageSkipWaiting();
  }
}

/**
 * Deregistra il SW (utile in sviluppo o se si vuole disabilitare la PWA).
 */
export function unregisterSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch((err) => console.error('[SW] Deregistrazione fallita:', err));
  }
}
